export const AERATION_GRID_TITLE = 'claim.declaration.external_damages.form.aeration_grid.count.title';
